import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { formHasErrors } from "util/FormsUtils";
import { Col, Form, ButtonToolbar, Button, Alert, Input } from "components/bootstrap";
import { FormikFormGroup, ExternalLink } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const OidcGroupSyncForm = ({
  values,
  isSubmitting,
  handleSubmit,
  validateForm,
  submitAllError,
  goToPrevious
}) => {
  const { t } = useTranslation("enterprise_authentication");
  const productName = useProductName();
  const sendTelemetry = useSendTelemetry("oidc-groupsync-step");
  const onSubmitAll = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.AUTHENTICATION.OIDC_GROUP_SYNC_SAVE_CLICKED, {
      app_action_value: "save-service"
    });
    if (values.synchronizeGroups) {
      return validateForm().then((errors) => {
        if (!formHasErrors(errors)) {
          handleSubmit();
        }
      });
    }
    return handleSubmit();
  };
  const disableForm = !values.synchronizeGroups;
  return /* @__PURE__ */ React.createElement(Col, { md: 7 }, /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", title: t("oidc.oidc_group_sync_form.introduction_title") }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "oidc.oidc_group_sync_form.introduction",
      values: { productName },
      components: {
        externalLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://openid.net/specs/openid-connect-core-1_0.html#UserInfo" }),
        i: /* @__PURE__ */ React.createElement("i", null)
      }
    }
  )), /* @__PURE__ */ React.createElement(
    Input,
    {
      label: t("oidc.oidc_group_sync_form.enable_group_sync"),
      id: "synchronize-groups-checkbox",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        label: t("oidc.oidc_group_sync_form.synchronize_groups"),
        wrapperClassName: "col-sm-12",
        name: "synchronizeGroups",
        help: t("oidc.oidc_group_sync_form.synchronize_groups_help"),
        type: "checkbox"
      }
    )
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      label: t("oidc.oidc_group_sync_form.groups_claim"),
      type: "text",
      help: t("oidc.oidc_group_sync_form.groups_claim_help"),
      labelClassName: "col-sm-3",
      name: "groupsClaim",
      disabled: disableForm,
      wrapperClassName: "col-sm-9"
    }
  )), submitAllError, /* @__PURE__ */ React.createElement(ButtonToolbar, { className: "pull-right" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      disabled: isSubmitting,
      onClick: () => {
        sendTelemetry(TELEMETRY_EVENT_TYPE.AUTHENTICATION.OIDC_PREVIOUS_SERVER_CONFIG_CLICKED, {
          app_action_value: "server-configuration-button"
        });
        goToPrevious();
      },
      type: "button"
    },
    t("oidc.oidc_group_sync_form.previous_server_configuration")
  ), /* @__PURE__ */ React.createElement(Button, { disabled: isSubmitting, onClick: onSubmitAll }, t("oidc.oidc_group_sync_form.finish_and_save")))));
};
export default OidcGroupSyncForm;
